import React from 'react';

export default function SafeIcon({ icon: Icon, className = "", style = {}, ...props }) {
  if (!Icon) return null;
  return <Icon className={className} style={style} {...props} />;
}